<!--
  This script has many commented lines to that add a first STEP that lets the
  user select between HORECA and RETAIL, so when the time comes it will be
  easier to add this feature.
-->
<template>
  <v-card-text class="pa-0">
    <v-toolbar
      flat
      color="transparent"
    >
      <!--v-btn
        icon
        :disabled="stepper === 4"
        @click="back()"
      -->
      <v-btn
        icon
        :disabled="stepper === 3"
        @click="back()"
      >
        <v-icon v-text="icons.back" />
      </v-btn>
      <v-toolbar-title
        class="text-subtitle-1 font-weight-bold"
        v-text="__('demoTitle')"
      />
    </v-toolbar>
    <v-stepper
      v-model="stepper"
      flat
      class="transparent"
    >
      <v-stepper-header class="elevation-0">
        <v-stepper-step
          step="1"
          :complete="stepper > 1"
        />
        <v-divider />
        <v-stepper-step
          step="2"
          :complete="stepper > 2"
        />
        <v-divider />
        <!--v-stepper-step
          step="3"
          :complete="stepper > 3"
        />
        <v-divider />
        <v-stepper-step
          step="4"
          :complete="accountCreated"
        /-->
        <v-stepper-step
          step="3"
          :complete="accountCreated"
        />
      </v-stepper-header>
      <v-stepper-items>
        <!--v-stepper-content step="1">
          <h-demo-title>¿Qué sector.......... ?</h-demo-title>
          <v-item-group
            v-model="form.type"
            class="my-8"
            @change="next()"
          >
            <v-item
              value="xef"
              v-slot="{ active, toggle }"
            >
              <v-btn
                depressed
                x-large
                :color="active ? 'primary' : 'grey'"
                class="text-none px-3 py-10 mr-2"
                @click="toggle"
              >
                Restauradores<br>
                HORECA
              </v-btn>
            </v-item>
            <v-item
              value="retail"
              v-slot="{ active, toggle }"
            >
              <v-btn
                depressed
                x-large
                :color="active ? 'primary' : 'grey'"
                class="text-none px-3 py-10 ml-2"
                @click="toggle"
              >
                Comercios<br>
                RETAIL
              </v-btn>
            </v-item>
          </v-item-group>
        </v-stepper-content>
        <v-stepper-content step="2"-->
        <v-stepper-content step="1">
          <h-demo-title v-text="__('demoStep1Title')" />
          <v-item-group
            v-model="form.business"
            @change="next()"
          >
            <v-row dense>
              <v-col
                v-for="id in businesses"
                :key="id"
                cols="6"
              >
                <v-item
                  :value="id"
                  v-slot="{ active, toggle }"
                >
                  <v-btn
                    depressed
                    large
                    block
                    :color="active ? 'primary' : 'grey'"
                    height="72"
                    class="text-none"
                    style="line-height: 1.1; border-radius: 12px;"
                    @click="toggle"
                    v-html="__(`demoStep1Business${id}`)"
                  />
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
        </v-stepper-content>
        <!--v-stepper-content step="3"-->
        <v-stepper-content step="2">
          <h-demo-title v-text="__('demoStep2Title')" />
          <v-text-field
            v-model="form.email"
            type="email"
            solo
            flat
            light
            background-color="grey lighten-2"
            class="my-6"
            :prepend-inner-icon="icons.email"
            placeholder="you@example.com"
            :readonly="sending"
            hide-details
            @keyup.enter="$event.target.blur()"
          />
          <v-checkbox
            v-model="form.checked"
            :ripple="false"
            :readonly="sending"
          >
            <template #label>
              {{ __('demoStep2Accept') }}&nbsp;
              <span class="white--text font-weight-medium">
                <h-demo-conditions />
              </span>
            </template>
          </v-checkbox>
          <div class="text-center">
            <v-btn
              depressed
              color="primary"
              class="my-6"
              :disabled="! canCreate"
              :loading="sending"
              @click="validate()"
              v-text="__('demoCreate')"
            />
          </div>
        </v-stepper-content>
        <!--v-stepper-content step="4"-->
        <v-stepper-content step="3">
          <div v-if="! accountCreated">
            <h-demo-title v-text="__('demoCreating')" />
            <v-progress-linear
              height="6"
              background-color="grey lighten-1"
              indeterminate
              class="my-12"
            />
          </div>
          <div v-else-if="accountError">
            <h-demo-title v-text="__('demoFailedTitle')" />
            <p v-text="__('demoFailedText')" />
            <div class="text-center">
              <v-btn
                depressed
                x-large
                color="primary"
                class="my-8"
                :loading="sending"
                @click="retry()"
                v-text="__('demoCreate')"
              />
            </div>
          </div>
          <div v-else>
            <h-demo-title v-text="__('demoSuccessTitle')" />
            <p v-text="__('demoSuccessText')" />
            <div class="text-center">
              <v-btn
                depressed
                x-large
                color="primary"
                class="my-8"
                :loading="sending"
                @click="login()"
              >
                {{ __('login') }}
              </v-btn>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-snackbar
      v-model="showError"
      color="white"
      text
      timeout="8000"
    >
      <span class="text-subtitle-1" v-html="$store.state.alert.message" />
      <template #action="{ attrs }">
        <v-btn
          color="primary"
          icon
          v-bind="attrs"
          @click="showError = false"
        >
          <v-icon v-text="icons.close" />
        </v-btn>
      </template>
    </v-snackbar>
  </v-card-text>
</template>

<script>
  import axios from 'axios'
  import { Inertia } from '@inertiajs/inertia'
  import HandlesInertiaExceptions from '@/Mixins/HandlesInertiaExceptions'
  import I18n from '@/Mixins/I18n'
  import Lockable from '@/Mixins/Lockable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HDemoConditions from '@/Components/Legal/DemoConditions'
  import HDemoTitle from './DemoTitle'
  import Version from '@/version.json'

  export default {
    mixins: [
      HandlesInertiaExceptions,
      I18n,
      Lockable,
      UsesIcons,
    ],

    components: {
      HDemoConditions,
      HDemoTitle,
    },

    data: () => ({
      stepper: 1,
      businesses: [ 39, 40, 45, 46, 69, 47 ], // database IDs
      form: {
        // type: undefined,
        type: 'xef',
        business: undefined,
        email: undefined,
        checked: false,
      },
      sending: false,
      accountCreated: false,
      accountError: false,
      credentials: {},
      Version,
    }),

    computed: {
      canCreate () {
        return this.validEmail && this.form.checked
      },
      validEmail () {
        // https://vuejs.org/v2/cookbook/form-validation.html
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.form.email)
      },
      showError: {
        get () {
          return this.$store.state.alert.show
        },
        set (v) {
          if (! v) {
            this.$store.dispatch('alert/hide')
          }
        }
      },
    },

    methods: {
      next () {
        if (this.locked) {
          return
        }
        this.lock(400)
        setTimeout(() => this.stepper++, 250)
      },
      back () {
        switch (this.stepper) {
          case 1:
            this.$emit('back')
            return
          case 2:
          //   this.form.type = undefined
          // case 3:
            this.form.business = undefined
            this.form.checked = false
        }
        this.stepper--
      },
      showInertiaException (message) {
        this.$store.dispatch('alert/showWarning', message)
      },
      validate () {
        this.sending = true
        axios.post('/demo/validate', this.form)
          .then(r => {
            this.form = {...this.form, username: r.data.username}
            this.stepper++
            this.create()
          })
          .catch(e => this.$store.dispatch('xError', e))
          .finally(() => this.sending = false)
      },
      create () {
        this.sending = true
        axios.post('/demo/create', this.form)
          .then(r => this.credentials = r.data)
          .catch(e => {
            this.$store.dispatch('xError', e)
            this.accountError = true
          })
          .finally(() => {
            this.sending = false
            this.accountCreated = true
          })
      },
      retry () {
        this.accountCreated = false
        this.accountError = false
        this.create()
      },
      login () {
        Inertia.post('', {
          ...this.credentials,
          model: `${AndroidDevice.model()} - ${AndroidDevice.version()} - ${this.$page.props.brand}-DEMO v${this.Version.long}`,
          description: AndroidDevice.description(),
        }, {
          preserveState: true,
          onBefore: visit => this.sending = true,
          onError: errors => this.showInertiaException(Object.values(errors).join('<br>')),
          // onSucces we do nothing because the backend will redirect for us
          onFinish: () => this.sending = false,
        })
      },
    },
  }
</script>
